var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { feathersServices, feathersAuthentication } from 'src/feathers';
import ButtonLogin from './ButtonLogin';
var selfStyles = require('./ButtonLoginDev.scss');
var ButtonLoginDev = (function (_super) {
    __extends(ButtonLoginDev, _super);
    function ButtonLoginDev(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCreateLocalUser = _this.handleCreateLocalUser.bind(_this);
        _this.handleLoginLocalUser = _this.handleLoginLocalUser.bind(_this);
        _this.handleLogoutLocalUser = _this.handleLogoutLocalUser.bind(_this);
        return _this;
    }
    ButtonLoginDev.prototype.handleCreateLocalUser = function () {
        this.props.actions.handleCreateUser({
            email: 'hello@crimp.rocks',
            password: 'hellocrimprocks',
        });
    };
    ButtonLoginDev.prototype.handleLoginLocalUser = function () {
        var _this = this;
        this.props.actions.handleLoginRequest({
            strategy: 'local',
            email: 'hello@crimp.rocks',
            password: 'hellocrimprocks',
        }).then(function (res) {
            _this.props.navigateToNext();
        });
    };
    ButtonLoginDev.prototype.handleLogoutLocalUser = function () {
        this.props.actions.handleLogoutRequest();
    };
    ButtonLoginDev.prototype.render = function () {
        return (React.createElement("div", { className: selfStyles.wrapper },
            React.createElement("p", null,
                "Development Environment",
                React.createElement("br", null),
                "See console for operations"),
            React.createElement(ButtonLogin, null,
                React.createElement("button", { className: selfStyles.local, onClick: this.handleCreateLocalUser }, "Create User")),
            React.createElement(ButtonLogin, null,
                React.createElement("button", { className: selfStyles.local, onClick: this.handleLoginLocalUser }, "Login User")),
            React.createElement(ButtonLogin, null,
                React.createElement("button", { className: selfStyles.local, onClick: this.handleLogoutLocalUser }, "Logout"))));
    };
    return ButtonLoginDev;
}(React.Component));
var mapStateToProps = function (state) { return ({
    isAuthenticated: state.auth.isSignedIn,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({
        handleCreateUser: feathersServices.users.create,
        handleLoginRequest: feathersAuthentication.authenticate,
        handleLogoutRequest: feathersAuthentication.logout,
    }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(ButtonLoginDev);



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/ButtonLoginDev.tsx
// module id = 723
// module chunks = 0